export const hours = (duration) => `00${Math.floor(duration / 3600)}`.slice(-2);
export const minutes = (duration) => `${Math.floor(duration / 60)}`;
export const seconds = (duration) => `00${Math.floor(duration) % 60}`.slice(-2);
